import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import {
    IThinkAnalyticsSearchSuggestionRequest,
    IThinkAnalyticsSearchSuggestionResponse,
} from '../../../entity/interface/iThinkAnalyticsSearch';
import { IThinkAnalyticsSearchRepository } from '../../repositories/interfaces/iThinkAnalyticsSearchRepository';

export interface IGetSearchSuggestionsUseCase {
    execute(
        payload: IThinkAnalyticsSearchSuggestionRequest,
        identityToken: string
    ): Promise<IThinkAnalyticsSearchSuggestionResponse>;
}

export class GetSearchSuggestionsUseCase implements IGetSearchSuggestionsUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get thinkAnalyticsSearchRepository(): IThinkAnalyticsSearchRepository {
        return container.resolve<IThinkAnalyticsSearchRepository>(DI.REPOSITORIES.IThinkAnalyticsSearchRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async execute(
        payload: IThinkAnalyticsSearchSuggestionRequest,
        identityToken: string
    ): Promise<IThinkAnalyticsSearchSuggestionResponse> {
        return this.thinkAnalyticsSearchRepository.searchSuggestions(payload, identityToken);
    }
}
